import { Stack, Tabs } from '@mantine/core'
import flatten from 'lodash/flatten'

import { Category, KeyPillarsArticlesType } from 'interfaces/types'

import { Categories } from '../categories'
import { SliderAdvanceLayout } from '../sliderAdvanceLayout'
import { SliderNormalLayout } from '../sliderNormalLayout'

type Props = {
  activeIndex: number
  listByGroup: KeyPillarsArticlesType[]
  dataTrackingCommon: any
  categories: Category[]
}
export const KeyPillarLayout = ({
  activeIndex,
  listByGroup = [],
  dataTrackingCommon,
  categories,
}: Props) => {
  return (
    <Stack spacing={40}>
      <Tabs
        value={String(activeIndex)}
        keepMounted
        styles={{
          root: {
            position: 'relative',
          },
          panel: {
            display: 'block !important',
            transition: 'opacity 0.2s ease',
            '&.inactive': {
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              opacity: 0,
              zIndex: 0,
            },
            '&.active': {
              position: 'relative',
              zIndex: 1,
            },
          },
        }}
      >
        <Tabs.Panel
          value={String(-1)}
          className={activeIndex === -1 ? 'active' : 'inactive'}
        >
          <SliderAdvanceLayout
            articles={flatten(listByGroup.map((j) => j.articles))}
            dataTrackingCommon={dataTrackingCommon}
            keepMobileLayoutSameDesktop
            // processClass={{
            //   processRoot: classes.processRoot,
            //   processBar: classes.processBar,
            // }}
          />
        </Tabs.Panel>
        {listByGroup.map((i, idx) => (
          <Tabs.Panel
            value={String(idx)}
            className={activeIndex === idx ? 'active' : 'inactive'}
            key={idx}
          >
            <SliderNormalLayout
              articles={i.articles}
              layout={'list-contain-ads'}
              dataTrackingCommon={dataTrackingCommon}
            />
          </Tabs.Panel>
        ))}
      </Tabs>
      <Categories categories={categories} />
    </Stack>
  )
}
